window.addEventListener('scroll', function() {
  var header = document.querySelector('.template-index .jeremi-sticky');
  if (window.scrollY > 50) { // Adjust the scroll threshold as needed
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});



//Red Font NEW
  // Halloween Collection – Desktop
const desktopHalloween = document.querySelector('#HeaderMenu-dead-threads-collections-halloween-october-only');
if (desktopHalloween) {
  desktopHalloween.innerHTML =
    'HALLOWEEN <span style="color:#e32624; padding-left:5px; font-weight: bold;">(OCTOBER ONLY)</span>';
}

// Halloween Collection – Mobile
const mobileHalloween = document.querySelector('#HeaderDrawer-dead-threads-collections-halloween-october-only');
if (mobileHalloween) {
  mobileHalloween.innerHTML =
    'HALLOWEEN <span style="color:#e32624; padding-left:5px; font-weight: bold;">(OCTOBER ONLY)</span>';
}

// Breast Cancer Awareness Month – Desktop
const desktopBCA = document.querySelector('#HeaderMenu-dead-threads-collections-breast-cancer-awareness-month');
if (desktopBCA) {
  desktopBCA.innerHTML =
    'BREAST CANCER AWARENESS MONTH <span style="color:#ff69b4; padding-left:5px; font-weight: bold;">(OCTOBER ONLY)</span>';
}

// Breast Cancer Awareness Month – Mobile
const mobileBCA = document.querySelector('#HeaderDrawer-dead-threads-collections-breast-cancer-awareness-month');
if (mobileBCA) {
  mobileBCA.innerHTML =
    'BREAST CANCER AWARENESS MONTH <span style="color:#ff69b4; padding-left:5px; font-weight: bold;">(OCTOBER ONLY)</span>';
}


//Remove item in cart when it reaches 0
document.addEventListener('DOMContentLoaded', () => {
  // Handle "minus" click in drawer/cart page
  document.addEventListener('click', function (evt) {
    const btn = evt.target.closest('.quantity__button[name="minus"]');
    if (!btn) return;                       // Not a minus button

    const input   = btn.parentElement.querySelector('.quantity__input');
    const line    = input.dataset.index;    // e.g. "1"
    const current = parseInt(input.value, 10);

    // Only intercept when qty would drop from 1 → 0
    if (current !== 1) return;

    evt.preventDefault();                   // Stop default decrement
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:   JSON.stringify({ line, quantity: 0 })
    })
    .then(r => r.json())
    .then(cart => {
      // Spotlight has this helper – reuse it if present
      if (window.CartDrawer && typeof CartDrawer.reloadContents === 'function') {
        CartDrawer.reloadContents(cart);
      } else {
        // Fallback: reload page if Drawer helper not found
        location.reload();
      }
    });
  }, true);
});



//Garment Javascript
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.option-item').forEach(option => {
      option.addEventListener('click', function(e) {
        const dropdown = this.closest('.custom-dropdown');
        const selected = dropdown.querySelector('.dropdown-selected');
        const url = this.getAttribute('data-url');

        selected.textContent = this.textContent;
        dropdown.classList.remove('open');

        if (url) {
          window.location.href = url;
        }
      });
    });

    // Close dropdown if clicked outside
    document.addEventListener('click', function(e) {
      document.querySelectorAll('.custom-dropdown.open').forEach(drop => {
        if (!drop.contains(e.target)) drop.classList.remove('open');
      });
    });
  });
